/**
 * Manifest file for all Class modules that can be instantiated
 * by the main App.
 *
 * All modules should be alpha-ordered and imported using the async import syntax.
 * The key value for `name` should match the component `data-cmp-is` value, and the value should be the
 * component's import path
 * e.g.
 *  {
 *    name: 'accordion',
 *    loader: () => import('./components/modules/Accordion')
 *  }
 */
export const moduleMap = [
  {
    name: 'accordion',
    loader: () => import('./components/foundation/Accordion')
  },
  {
    name: 'agenda-listing',
    loader: () => import('./components/foundation/AgendaListing')
  },
  {
    name: 'alert-banner',
    loader: () => import('./components/foundation/AlertBanner')
  },
  {
    name: 'audio-block',
    loader: () => import('./components/foundation/AudioBlock')
  },
  {
    name: 'be-ix-links',
    loader: () => import('./components/modules/BeIxLinks')
  },
  {
    name: 'autosized-video',
    loader: () => import('./components/foundation/AutosizedVideo')
  },
  {
    name: 'blog-detail-hero',
    loader: () => import('./components/modules/BlogDetailHero')
  },
  {
    name: 'legacy-video',
    loader: () => import('./components/foundation/BlogLegacyVideo')
  },
  {
    name: 'blog-sub-nav',
    loader: () => import('./components/modules/BlogSubNav')
  },
  {
    name: 'basic-filter',
    loader: () => import('./components/product-hub-components/BasicFilter')
  },
  {
    name: 'basic-cta',
    loader: () => import('./components/foundation/BasicCta')
  },
  {
    name: 'card-carousel',
    loader: () => import('./components/components/Carousels/CardCarousel')
  },
  {
    name: 'carousel-of-card-carousels',
    loader: () => import('./components/components/Carousels/CarouselOfCardCarousels')
  },
  {
    name: 'category-tab',
    loader: () => import('./components/components/CategoryTabs')
  },
  {
    name: 'column',
    loader: () => import('./components/modules/Columns')
  },
  {
    name: 'cta-footer-sticky',
    loader: () => import('./components/foundation/CtaFooterSticky')
  },
  {
    name: 'ebook-cta-card',
    loader: () => import('./components/foundation/EbookCtaCard')
  },
  {
    name: 'ebook-hero',
    loader: () => import('./components/modules/EbookHero')
  },
  {
    name: 'ebookOffset',
    loader: () => import('./components/foundation/EbookOffsetImageSectionTitle')
  },
  {
    name: 'event-hero',
    loader: () => import('./components/modules/EventHero')
  },
  {
    name: 'expanding-card',
    loader: () => import('./components/foundation/ExpandingCard')
  },
  {
    name: 'fdn-logo-slide',
    loader: () => import('./components/foundation/LogoSlide')
  },
  {
    name: 'lottie-animation',
    loader: () => import('./components/foundation/LottieAnimation')
  },
  {
    name: 'fdn-speaker-card',
    loader: () => import('./components/foundation/SpeakerCard')
  },
  {
    name: 'footer',
    loader: () => import('./components/modules/Footer')
  },
  {
    name: 'form',
    loader: () => import('./components/foundation/Forms')
  },
  {
    name: 'gridLandingPage',
    loader: () => import('./components/foundation/GridLandingPage')
  },
  {
    name: 'image-card-expandable',
    loader: () => import('./components/foundation/ImageCard')
  },
  {
    name: 'image-cta',
    loader: () => import('./components/foundation/ImageCta')
  },
  {
    name: 'hero',
    loader: () => import('./components/modules/Hero')
  },
  {
    name: 'hero-banner-card',
    loader: () => import('./components/foundation/HeroBannerCard')
  },
  {
    name: 'navigation',
    loader: () => import('./components/modules/Navigation')
  },
  {
    name: 'newsletter-signup',
    loader: () => import('./components/foundation/NewsletterSignup')
  },
  {
    name: 'pricing-card',
    loader: () => import('./components/foundation/PricingCard')
  },
  {
    name: 'product-copy',
    loader: () => import('./components/foundation/ProductCopyBlock')
  },
  {
    name: 'nested-tab',
    loader: () => import('./components/components/ProductNestedTab')
  },
  {
    name: 'result-card',
    loader: () => import('./components/components/ResultCardGrid')
  },
  {
    name: 'social-sharing',
    loader: () => import('./components/foundation/SocialSharing')
  },
  {
    name: 'StickyNav',
    loader: () => import('./components/components/StickyNav')
  },
  {
    name: 'sub-nav',
    loader: () => import('./components/modules/SubNav')
  },
  {
    name: 'smb-calculator',
    loader: () => import('./components/modules/SMBROICalculator')
  },
  {
    name: 'tabbed-carousel',
    loader: () => import('./components/foundation/TabbedCarousel')
  },
  {
    name: 'tabbed-pills',
    loader: () => import('./components/foundation/TabbedPills')
  },
  {
    name: 'table',
    loader: () => import('./components/foundation/Table')
  },
  {
    name: 'tabs',
    loader: () => import('./components/foundation/Tabs')
  },
  {
    name: 'timeline',
    loader: () => import('./components/foundation/Timeline')
  },
  {
    name: 'testimonial-carousel',
    loader: () => import('./components/foundation/TestimonialCarousel')
  },
  {
    name: 'video-expander',
    loader: () => import('./components/modules/VideoExpander')
  },
  {
    name: 'fdnModal',
    loader: () => import('./components/foundation/Modal')
  },
  {
    name: 'security-bulletin',
    loader: () => import('./components/pages/SecurityBulletinDetail')
  },
  {
    name: 'zoom-hardware',
    loader: () => import('./components/pages/Hardware')
  },
  {
    name: 'megamenu-categories',
    loader: () => import('./components/components/ProductCategories')
  },
  {
    name: 'navigator',
    loader: () => import('./components/modules/Navigator')
  },
  {
    name: 'jw-player',
    loader: () => import('./components/modules/jwplayer')
  },
  {
    name: 'json-filter',
    loader: () => import('./components/components/JsonFilter')
  },
  {
    name: 'workflow-quiz',
    loader: () => import('./components/components/WorkflowQuiz')
  },
  {
    name: 'ai-impact-calculator',
    loader: () => import('./components/components/AiImpactCalculator')
  },
  {
    name: 'aic-roc-calculator',
    loader: () => import('./components/components/AicRoiCalculator')
  },
  {
    name: 'fdn-ebook-quote-carousel',
    loader: () => import('./components/foundation/EbookQuote')
  },
  {
    name: 'pricingcard-standard',
    loader: () => import('./components/components/PricingCardStandard')
  },
  {
    name: 'pricingcard-standard-basic',
    loader: () => import('./components/components/PricingCardStandardBasic')
  },
  {
    name: 'pricingcard-uni',
    loader: () => import('./components/components/PricingCardUni')
  },
  {
    name: 'title-with-icon-tooltip',
    loader: () => import('./components/modules/SectionTitleWithIconTooltip')
  },
  {
    name: 'take-back-lunch-lp',
    loader: () => import('./components/modules/TakeBackLunchLP')
  },
  {
    name: 'audience-hero',
    loader: () => import('./components/modules/AudienceHero')
  },
  {
    name: 'product-inquiry',
    loader: () => import('./components/components/ProductInquiry')
  },
  {
    name: 'fdn-custom-dropdown',
    loader: () => import('./components/foundation/Dropdown')
  },
  {
    name: 'pricingcard-silver',
    loader: () => import('./components/components/PricingCardSilver')
  },
  {
    name: 'fdn-zm-tabs',
    loader: () => import('./components/modules/VerticalTabs')
  },
  {
    name: 'hero-carousel',
    loader: () => import('./components/modules/HeroCarousel')
  },
  {
    name: 'product-features',
    loader: () => import('./components/pages/ProductFeatures')
  },
  {
    name: 'fdn-zdcm-accordion-tab',
    loader: () => import('./components/product-hub-components/feature-tab-accordion')
  },
  {
    name: 'use-case-template',
    loader: () => import('./components/pages/UseCaseTemplate')
  },
  {
    name: 'fdn-tooltip',
    loader: () => import('./components/foundation/Tooltip')
  },
  {
    name: 'fdn-zero-abjcoverage',
    loader: () => import('./components/pages/0ABJCoverage')
  },
  {
    name: 'star-ratings',
    loader: () => import('./components/foundation/StarRatings')
  },
  {
    name: 'zdcm-header',
    loader: () => import('./components/product-hub-components/NavigationHub')
  },
  {
    name: 'custom-swiper-slider',
    loader: () => import('./components/product-hub-components/CustomSwiperSlider')
  },
  {
    name: 'zdcm-resources-block',
    loader: () => import('./components/product-hub-components/resources-block')
  },
  {
    name: 'zdcm-resources-carousel',
    loader: () => import('./components/product-hub-components/ResourcesSlider')
  },
  {
    name: 'zdcm-service-cards',
    loader: () => import('./components/product-hub-components/service-cards')
  },
  {
    name: 'fdn-zdcm-customer-stories',
    loader: () => import('./components/product-hub-components/CustomerStoriesNewCards')
  },
  {
    name: 'zdcm-customer-stories-expanded-card',
    loader: () => import('./components/product-hub-components/CustomerStoriesExpandedCards')
  },
  {
    name: 'pricing-card-v1',
    loader: () => import('./components/product-hub-components/pricing-cards-v1')
  },
  {
    name: 'zdcm-module-footer',
    loader: () => import('./components/product-hub-components/Footer-v1')
  },
  {
    name: 'zdcm-discover-products',
    loader: () => import('./components/product-hub-components/DiscoverProducts')
  },
  {
    name: 'zdcm-competitive-image',
    loader: () => import('./components/product-hub-components/competitive-comparison')
  },
  {
    name: 'zdcm-zoom-vs-slack-tab',
    loader: () => import('./components/product-hub-components/ZoomvsSlackTab')
  },
  {
    name: 'zdcm-docs-slider',
    loader: () => import('./components/product-hub-components/DocsSlider')
  },
  {
    name: 'zdcm-common-swiper-slider',
    loader: () => import('./components/product-hub-components/CommonSliderWrapper/CommonSliderWrapper')
  },
  {
    name: 'zdcm-lead-generation',
    loader: () => import('./components/product-hub-components/LeadGenerationNavigation/LeadGenerationNavigation')
  },
  {
    name: 'announcement-card',
    loader: () => import('./components/product-hub-components/AnnouncementCardGridLayout/AnnouncementCardGridLayout')
  },
  {
    name: 'zdcm-header-individual',
    loader: () => import('./components/product-hub-components/NavigationIndividual/NavigationIndividual')
  },

  {
    name: 'zdcm-hr-benefits',
    loader: () => import(/* webpackChunkName: 'zdcm-hr-benefits' */ './components/product-hub-components/HR-Benfits/HRBenefitsNavigation/HRBenefitsNavigation')
  },
  {
    name: 'zdcm-hr-benefits-contact-info',
    loader: () => import(/* webpackChunkName: 'zdcm-hr-benefits-contact-info' */ './components/product-hub-components/HR-Benfits/ContactInfo')
  },
  {
    name: 'zdcm-feature-spotlight',
    loader: () => import('./components/product-hub-components/FeatureSpotLight')

  },
  {
    name: 'zdcm-interactive-video-playlist',
    loader: () => import('./components/product-hub-components/InteractiveVideoPlaylist')
  },
  {
    name: 'navigation-workplace',
    loader: () => import('./components/product-hub-components/NavigationWorkplace/NavigationWorkplace')
  },
  {
    name: 'optimizely-init',
    loader: () => import('./components/foundation/OptimizelyInit')
  }
]
